import styled from 'styled-components'

export const Wrapper = styled.form`
  display: block;
  width: 100%;
  height: auto;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 4px;
  background-color: ${({ theme }) => theme.ds.colors.neutral25};
  border: 1px solid ${({ theme }) => theme.ds.colors.neutral100};
`

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 32px;

  > .filename {
    word-break: break-all;
  }
`

export const CardContent = styled.div`
  .select-status {
    &.-status-approved {
      color: ${({ theme }) => theme.ds.colors.success700};
    }

    &.-status-disapproved {
      color: ${({ theme }) => theme.ds.colors.danger800};
    }
  }
`

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > .btn {
    cursor: pointer;
    width: 20px;
    height: 20px;

    path {
      stroke: ${({ theme }) => theme.ds.colors.primary400};
    }
  }
`
